import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CustomStep from 'workOrderComponents/close/CustomStep';
import { OptimizationStatusConfig } from '../../constants/optimizationStatusConfig';


class OutletOptimizationStatusStep extends React.Component {

    constructor(props) {
        super(props);
        this.handleStatusChange = this
            .handleStatusChange
            .bind(this);
    }

    handleStatusChange(e, index, value) {
        e.preventDefault();
        const { workOrderActions, orderId } = this.props;

        workOrderActions.outletOptimizationStatusSet(value, orderId);
    }

    render() {
        const { orderCloseDetails, stepConfig, orderId, workOrderActions, disabled } = this.props;

        const currentStatus = orderCloseDetails.getIn(['closeOrderRequest','outletOptimizationStatus']);
        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');

        const menuItems = OptimizationStatusConfig
            .filter(item => item.value !== 3)
            .map((item, index) => (
                <MenuItem
                    key={`status_item_${index}`}
                    value={item.value}
                    primaryText={item.message}
                />
            ));

        return (

            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={`Outlet Optimization`}
                stepConfig={stepConfig}
                stepConfigKey="outletOptimizationStatusStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="outletOptimization">
                <SelectField
                    floatingLabelText="Select Outlet Optimization Status"
                    value={currentStatus}
                    disabled={disabled}
                    onChange={this.handleStatusChange}>

                    {menuItems}

                </SelectField>
            </CustomStep>

        );

    }
}

OutletOptimizationStatusStep.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    stepConfig: PropTypes.object,
    disabled: PropTypes.bool,
    serviceTypeId: PropTypes.string
};

export default OutletOptimizationStatusStep;


// WEBPACK FOOTER //
// ./src/components/outlet-optimization/OutletOptimizationStatusStep.js